// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useTheme } from '@azure/communication-react';
import { ISpinnerStyles, ISpinnerProps, ITheme, Spinner } from '@fluentui/react';
import React, { useMemo } from 'react';

export const StyledSpinner = (props: ISpinnerProps): JSX.Element => {
  const theme = useTheme();
  const styles = useMemo(() => spinnerStyles(theme), [theme]);
  return <Spinner {...props} styles={styles} />;
};

const spinnerStyles = (theme: ITheme): ISpinnerStyles => ({
  label: {
    color: theme.palette.black
  },
  circle: {
    borderColor: `${theme.palette.black} ${theme.palette.themePrimary} ${theme.palette.themePrimary}`
  }
});
